
/*static type option*/
export const MARITAL_STATUS_OPTIONS = [
    { label: 'Single', value: 1 },
    { label: 'Married', value: 2 },
    { label: 'Divorced', value: 3 },
    { label: 'Widowed', value: 4 },
    { label: 'Principal', value: 5 },
    { label: 'Separated', value: 6 },
    { label: 'Engaged', value: 7 },
];

/*static type option*/
export const GENDER_OPTIONS = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 2 },
    { label: 'Unknown', value: 3 },
];

export const TITLE_OPTIONS = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mrs.', value: 'Mrs.' }
];

export const AGE_RANGE_OPTIONS = [
    { label: 'General', value: 1 },
    { label: 'Gender', value: 2 },
    { label: 'Marital Status', value: 3 },
    { label: 'Gender & Marital Status', value: 4 },
];
export const CATEGORY_OPTIONS = [
    { label: 'A', value: 'A' }, 
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' }  
];

export const POLICY_HOLDER_STATUS_OPTIONS = [
    { label: 'Created', value: 'Created' },
    { label: 'Active', value: 'Active' },
    { label: 'Cancelled', value: 'Cancelled' }
];


export const ACTIVE_INACTIVE_OPTIONS = [
    { label: 'All', value: 'All' },
    { label: 'Active', value: 'Active' },
    { label: 'InActive', value: 'InActive' }
];

export const CLAIM_STATUS = [
    { label: "Created", value: 1 },
    { label: "Awaiting Approval", value: 2 },
    { label: "Approved", value: 3 },
    { label: "Rejected", value: 4 },
    { label: "Paid", value: 5 },
];

export const CLAIM_STATUS_VALUE = [
    { label: "Created", value: "Created" },
    { label: "Awaiting Approval", value: "AwaitingApproval" },
    { label: "Approved", value: "Approved" },
    { label: "Rejected", value: "Rejected" },
    { label: "Paid", value: "Paid" },
];

export const RELATION_OPTIONS = [
    { label: 'Spouse', value: 'Spouse' },
    { label: 'Son', value: 'Son' },
    { label: 'Daughter', value: 'Daughter' },
];
